import { Link } from "react-router-dom";
import { fieldState, operatorVisible, privacyVisible, useSite } from "@/lib/content";
import { t } from "@/lib/i18n";
import { Logo } from "@/components/Logo";
import { getNavItems } from "@/components/navItems";
import { path } from "@/lib/routes";

export default function Footer() {
  const { content, isPreview, site } = useSite();
  const items = getNavItems(content, isPreview, site);
  const operatorName = fieldState(content?.operator?.legal_name, isPreview);
  const legal = [
    privacyVisible(content, isPreview) && { to: path("gizlilik"), label: t("footer.privacy"), id: "privacy" },
    operatorVisible(content, isPreview) && { to: `${path("iletisim")}#isletmeci`, label: t("footer.operator"), id: "operator" },
  ].filter(Boolean);

  return (
    <footer className="bg-cream-2 border-t border-line" data-testid="site-footer">
      <div className="safe-x max-w-7xl mx-auto py-14 lg:py-20 grid gap-10 lg:grid-cols-[1.2fr_1fr_1fr]">
        <div className="space-y-4">
          <Logo className="h-24 w-auto" testId="footer-logo-link" />
          <p className="text-wood font-serif text-xl" data-testid="footer-location-line">{t("footer.line")}</p>
          {operatorName.usable && <p className="text-sm text-ink-muted" data-testid="footer-operator-line">{t("footer.operatorLabel")}: {operatorName.value}</p>}
        </div>
        <nav aria-label={t("footer.nav")}>
          <ul className="grid gap-1">
            {items.map((i) => (
              <li key={i.key}>
                <Link to={i.to} className="inline-flex items-center min-h-[44px] min-w-[44px] text-ink-muted hover:text-forest transition-colors" data-testid={`footer-link-${i.key}`}>
                  {t(i.labelKey || `nav.${i.key}`)}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
        <div className="space-y-3">
          {legal.length > 0 && (
            <ul className="grid gap-1">
              {legal.map((l) => (
                <li key={l.id}>
                  <Link to={l.to} className="inline-flex items-center min-h-[44px] text-ink-muted hover:text-forest transition-colors" data-testid={`footer-link-${l.id}`}>{l.label}</Link>
                </li>
              ))}
            </ul>
          )}
          <p className="text-sm text-ink-muted leading-relaxed" data-testid="footer-not-official-note">{t("footer.note")}</p>
        </div>
      </div>
      <div className="safe-x max-w-7xl mx-auto border-t border-line py-6 text-xs text-ink-muted">
        © {new Date().getFullYear()} Woodia Polonez
      </div>
    </footer>
  );
}
